var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { class: ["portrait", { collapse: _vm.isCollapse }] }, [
      _c(
        "div",
        {
          class: [
            "portrait-img-content",
            { "portrait-img-content-margin": _vm.isCollapse },
          ],
        },
        [
          _c("el-image", {
            class: [
              "portrait-img",
              { "portrait-img-collapse": _vm.isCollapse },
            ],
            attrs: { src: _vm.pic_path, fit: "fill" },
            on: { click: _vm.gotoAccountSetting },
          }),
        ],
        1
      ),
      _c(
        "div",
        {
          class: [
            "portrait-name",
            { "portrait-name-collapse": _vm.isCollapse },
          ],
        },
        [
          _c(
            "div",
            {
              staticStyle: {
                height: "100%",
                display: "flex",
                "align-items": "center",
              },
            },
            [
              _c(
                "el-tooltip",
                {
                  attrs: {
                    disabled: _vm.mainUserName.length < 25,
                    placement: "top",
                    effect: "light",
                  },
                },
                [
                  _c("div", { attrs: { slot: "content" }, slot: "content" }, [
                    _vm._v(_vm._s(_vm.mainUserName)),
                  ]),
                  _vm.mainUserName.length >= 25
                    ? _c("p", { staticClass: "name-text" }, [
                        _vm._v(_vm._s(_vm.mainUserName)),
                      ])
                    : _c("p", [_vm._v(_vm._s(_vm.mainUserName))]),
                ]
              ),
            ],
            1
          ),
        ]
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }